import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=4abab9e3&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=ts&"
export * from "./UserItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=4abab9e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abab9e3",
  null
  
)

export default component.exports